
import { useDispatch, useSelector } from 'react-redux';
import './Greeter.css';
import React, { useEffect, useRef, useState } from 'react';
import { getGreeterCust } from '../API/Greeter/GreeterThunk';
import { selectUser } from '../ReduxStore/userReducer';
const GreeterAdd = ({ inputFields, handleInputChange, setDropdownVisibility, dropdownVisibility,
  setSuggestions, suggestions, focusedField, setFocusedField, values, setValues
}) => {
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const userData = useSelector(selectUser);
  const databaseName = userData?.DatabaseName;
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        const hidden = inputFields.reduce((acc, field) => {
          if (field.type === 'dropdown') acc[field.name] = false;
          return acc;
        }, {});
        setDropdownVisibility(hidden);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [inputFields]);
  const handleFocus = (field) => {
    const { name, dataSourceKey } = field;
    setFocusedField(name);
    if (Array.isArray(dataSourceKey)) {
      setSuggestions(dataSourceKey);
    } else {
      setSuggestions([]);
    }
    setDropdownVisibility(prev => ({ ...prev, [name]: true }));
  };
//   const handleItemClick = (item, field) => {
//   const { name, filterKey,relatedFields  } = field;
// console.log("item",item);

//   // if (name === 'name') {
//   //   setValues(prev => ({
//   //     ...prev,
//   //     [name]: item[filterKey],
//   //     phnumber: item.phoneNumber || '',
//   //     slp: item.slpName || '',
//   //   }));
 
//   if(name==='phnumber'){
//     setValues(prev => ({
//       ...prev,
//       [name]: item[filterKey],
//       name: item.name || '',
//       slp: item.slpName || '',
//     }));
//   }
//    else {
//     setValues(prev => ({
//       ...prev,
//       [name]: item[filterKey],
//     }));
//   }

//   setDropdownVisibility(prev => ({
//     ...prev,
//     [name]: false,
//   }));
// };
const handleItemClick = (item, field) => {
  const { name, filterKey, relatedFields } = field;
  setValues(prev => {
    let updatedValues = {
      ...prev,
      [name]: item[filterKey],
    };
    const fullValue = item[filterKey];
    if (name === 'phnumber') {
      const [phoneNumberPart, ...restParts] = fullValue.split(' - ');
      updatedValues.phnumber = phoneNumberPart.trim(); 
      updatedValues.name = item.name || '';
      updatedValues.slp = item.slpName || '';
      updatedValues.CustomerCode = item.customerCode || '';
      updatedValues.slpCode = item.slpCode || '';
      updatedValues.section = '';
    }
    if (relatedFields) {
      for (const [relatedKey, itemKey] of Object.entries(relatedFields)) {
        updatedValues[relatedKey] = item[itemKey] || '';
      }
    }
    return updatedValues;
  });
  setDropdownVisibility(prev => ({
    ...prev,
    [name]: false,
  }));
};
  return (
    <div className="row">
      {inputFields.map((field, index) => (
        <div key={index} className="col-12 mb-3 position-relative">
          <input
            type="text"
            className="form-control"
            placeholder={field.label}
            autoComplete="off"
            value={values[field.name]}
            // onClick={(e)=>handleClick(e,field)}
            onChange={(e) => handleInputChange(e, field)}
            onFocus={() => handleFocus(field)}
            style={{ outline: 'none', boxShadow: 'none' }}
          />

          {dropdownVisibility[field.name] && suggestions.length > 0 && focusedField === field.name && (
            <ul
              className="list-group position-absolute w-100"
              ref={dropdownRef}
              style={{ zIndex: 10, maxHeight: 200, overflowY: 'auto' }}
            >
              {suggestions.length > 0 ? (
                suggestions.map((item, idx) => (
                  <li
                    key={idx}
                    className="list-group-item list-group-item-action"
                    onClick={() => handleItemClick(item, field)}
                    style={{ cursor: 'pointer' }}
                  >
                    {item[field.filterKey]}
                  </li>
                ))
              ) : (
                <li className="list-group-item text-muted" style={{ cursor: 'default' }}>
                  No data found
                </li>
              )}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default GreeterAdd;
